<!--
 * @Description:
 * @Author: Mankeung
 * @Date: 2021-07-07 10:03:48
 * @LastEditors: Mankeung
 * @LastEditTime: 2021-07-27 22:10:10
-->

<style lang="scss" scoped>
.role {
  display: flex;
  color: #666; /** 公共的黑色 --暂定 */
  font-size: 14px;

  &Right {
    flex: 1;
    display: flex;
    overflow-x: hidden;
    flex-direction: column;

    &_Top {
      display: flex;
      gap: 15px;
      overflow-x: hidden;

      .el-input {
        width: auto;
      }
    }

    &_Container {
      margin-top: 20px;

      .screenshot {
        position: relative;
      }
    }

    &_pagenation {
      margin: 40px auto;
    }
  }
}

::v-deep .el-table th,
::v-deep .el-table td {
  text-align: center !important;
}
</style>
<template>
  <section>
    <div class="role">
      <div class="roleRight">
        <div class="roleRight_Top">
          <template v-if="searchShow">
            <el-input
                clearable
                v-model="search.searchKey"
                clas="input_search"
                placeholder="搜索关键字"
                @keyup.enter.native="getVipList"
            ></el-input>
            <el-select v-model="search.status" clearable placeholder="请选择">
              <el-option
                  v-for="item in COMMON_STATUS"
                  :key="item.key"
                  :label="item.name"
                  :value="item.key"
              ></el-option>
            </el-select>
            <el-button size="medium" type="primary" @click="getVipList"
            >查询
            </el-button
            >
          </template>

          <el-button
              v-if="addShow"
              size="medium"
              type="primary"
              @click="handleClick('addNext')"
          >新增
          </el-button
          >
        </div>
        <div class="roleRight_Container public-table-data">
          <el-table
              v-loading="loading"
              :data="tableData"
              size="medium"
              border
              style="width: 100%"
          >
            <el-table-column
                fixed
                prop="orgId"
                label="序号"
                type="index"
                width="100"
            >
            </el-table-column>
            <el-table-column prop="icon" label="ICON">
              <template slot-scope="scope">
                <el-image
                    v-if="scope.row.icon"
                    style="width: 50px; height: 50px"
                    :src="scope.row.icon"
                    fit="cover"
                ></el-image>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="名称"></el-table-column>
            <el-table-column prop="code" label="标识"></el-table-column>
            <el-table-column prop="payPrice" label="价格">
              <template slot-scope="scope">
                {{ scope.row.payPrice ? `￥${scope.row.payPrice / 100}` : "" }}
              </template>
            </el-table-column>
            <el-table-column prop="days" label="时间" min-width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.days">{{
                    scope.row.days ? `${scope.row.days} 天` : ""
                  }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="descr" label="说明" min-width="160">
            </el-table-column>
            <el-table-column prop="level" label="等级"></el-table-column>
            <el-table-column prop="status" label="状态" min-width="80">
              <template slot-scope="scope">
                <el-switch
                    :disabled="statusShow"
                    v-model="scope.row.status"
                    :active-value="1"
                    :inactive-value="0"
                    @change="handleSwitch(scope.$index)"
                ></el-switch>
              </template>
            </el-table-column>

            <el-table-column fixed="right" label="操作" min-width="220">
              <template slot-scope="scope">
                <el-button
                    v-if="editShow"
                    @click="handleClick('change', scope.row)"
                    plain
                    size="small"
                >修改
                </el-button
                >
                <el-button
                    v-if="benefitShow"
                    type="success"
                    plain
                    size="small"
                    @click="handleClick('right', scope.row)"
                >权益
                </el-button
                >
                <el-button
                    v-if="deleteShow"
                    type="primary"
                    plain
                    size="small"
                    @click="del(scope.row)"
                >删除
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <!-- 编辑弹框 -->
    <el-dialog
        :title="
        clickType == 'change'
          ? '修改会员等级'
          : clickType == 'addNext'
          ? '新增会员等级'
          : ' 会员权益'
      "
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="680px"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="80px"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item
                  label="ICON"
                  class="item"
                  v-if="clickType == 'change' || clickType == 'addNext'"
              >
                <!--图片部分-->
                <div class="screenshot">
              <span
                  v-for="(imgUrl, index) in srcList"
                  :key="index"
                  class="slideshow"
              >
                <div
                    class="icon-close"
                    @click="removeUploading(index)"
                    v-if="isMoer"
                >
                  <i class="el-icon-close"></i>
                </div>
                <el-image
                    style="width: 65px; height: 65px; border-radius: 6px"
                    :src="imgUrl"
                    fit="cover"
                    @click="getPolicy"
                />
              </span>
                  <div
                      v-loading="loading1"
                      class="up-btn"
                      style="width: 65px; height: 65px; line-height: 70px"
                      @click="getPolicy"
                      v-if="isMoer"
                  >
                    <i class="el-icon-plus"></i>
                  </div>
                </div>
                <input type="file" ref="file" @change="getFile"/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                  label="头图"
                  class="item"
                  v-if="clickType == 'change' || clickType == 'addNext'"
              >
                <!--图片部分-->
                <div class="screenshot">
              <span
                  v-for="(imgUrl, index) in logoSrcList"
                  :key="index"
                  class="slideshow"
              >
                <el-image
                    style="width: 65px; height: 65px; border-radius: 6px"
                    :src="imgUrl"
                    fit="cover"
                    @click="getLogoPolicy"
                />
              </span>
                  <div
                      v-loading="logoLoading"
                      class="up-btn"
                      style="width: 65px; height: 65px; line-height: 70px"
                      @click="getLogoPolicy"
                      v-if="isLogoMoer"
                  >
                    <i class="el-icon-plus"></i>
                  </div>
                </div>
                <input type="file" ref="logofile" @change="getLogoFile"/>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item
              label="背景图"
              v-if="clickType == 'change' || clickType == 'addNext'"
          >
            <div>
              <div class="diplay" style="margin-right: 10px">
                <div class="screenshot">
                  <span
                      v-for="(imgUrl, index) in srcListBg"
                      :key="index"
                      class="slideshow"
                  >
                    <div class="icon-close" @click="removeUploading(index)">
                      <i class="el-icon-close"></i>
                    </div>
                    <el-image
                        style="width: 175px; height: 75px; border-radius: 6px"
                        :src="imgUrl"
                        fit="cover"
                        @click="getPolicyBg"
                    />
                  </span>
                  <div
                      class="up-btn"
                      style="width: 175px; height: 75px; line-height: 80px"
                      @click="getPolicyBg"
                      v-loading="loading2"
                      v-if="isMoerBg"
                  >
                    <i class="el-icon-plus"></i>
                  </div>
                </div>
                <input
                    type="file"
                    ref="fileBg"
                    @change="getfileBg()"
                    accept="image/png,image/jpg"
                />
              </div>
            </div>
          </el-form-item>

          <el-row v-if="clickType == 'change' || clickType == 'addNext'">
            <el-col :span="12">
              <el-form-item label="名称" prop="name">
                <el-input
                    clearable
                    placeholder="会员等级名称"
                    v-model="params.name"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="标识" prop="code">
                <el-input
                    clearable
                    placeholder="标识必须唯一"
                    v-model="params.code"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item
              label="等级"
              prop="level"
              v-if="clickType == 'change' || clickType == 'addNext'"
          >
            <el-input
                clearable
                placeholder="等级"
                v-model="params.level"
                style="display: inline-block; max-width: 130px"
            ></el-input>
            <span style="color: #999; margin-left: 10px; font-size: 12px"
            >数字越小，等级越高</span
            >
          </el-form-item>
          <el-row v-if="clickType == 'change' || clickType == 'addNext'">
            <el-col :span="12">
              <el-form-item label="价格" prop="payPrice">
                <el-input
                    clearable
                    placeholder="会员价格"
                    v-model="params.payPrice"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="时间" prop="days">
                <el-input
                    clearable
                    placeholder="会员天数"
                    v-model="params.days"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">
              <span
                  style="text-algin: center; line-height: 40px; margin-left: 5px"
              >
                天</span
              >
            </el-col>
          </el-row>

          <el-row v-if="clickType == 'change' || clickType == 'addNext'">
            <el-col :span="22">
              <el-form-item label="说明">
                <el-input
                    type="textarea"
                    :rows="4"
                    maxlength="200"
                    placeholder="最长为200个字符"
                    v-model="params.descr"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item
              class="xq_editor"
              label="详情"
              v-if="clickType == 'change' || clickType == 'addNext'"
              prop="detail"
          >
            <richText v-if="dialogVisible" :keyWord="'detail'" :params="params?params:''"></richText>
            <!--            <quill-editor-->
            <!--              ref="editorComp"-->
            <!--              class="ql-toolbar"-->
            <!--              v-model="params.detail"-->
            <!--              :options="editorOption"-->
            <!--            >-->
            <!--            </quill-editor>-->
          </el-form-item>

          <el-form-item label="ICON :" class="item" v-if="clickType == 'right'">
            <el-image
                style="width: 65px; height: 65px; border-radius: 6px"
                :src="params.icon"
                fit="cover"
            ></el-image>
          </el-form-item>
          <el-row v-if="clickType == 'right'">
            <el-col :span="8">
              <el-form-item label="名称 :">
                <span>{{ params.name }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="标识 :">
                {{ params.code }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="权益 :" v-if="clickType == 'right'">
            <el-table
                v-loading="loading3"
                :data="rightData.concat([{ drugId: 0 }])"
                :span-method="arraySpanMethod"
                border
                style="width: 100%"
                class="rightTable"
            >
              <el-table-column label="序号" width="80">
                <template slot-scope="scope">
                  <div
                      @click="innerVisible = true"
                      v-if="scope.$index == rightData.length"
                      style="text-algin: center !important; color: #333"
                  >
                    <el-button
                        type="success"
                        class="el-icon-plus"
                        size="mini"
                        circle
                    ></el-button>
                  </div>
                  <div v-else>{{ scope.$index + 1 }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="icon" label="ICON">
                <template slot-scope="scope">
                  <el-image
                      v-if="scope.row.icon"
                      style="width: 50px; height: 50px"
                      :src="scope.row.icon"
                      fit="cover"
                  ></el-image>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="名称"></el-table-column>
              <el-table-column prop="code" label="标识"></el-table-column>
              <el-table-column prop="code" label="操作">
                <template slot-scope="scope">
                  <el-button
                      type="danger"
                      icon="el-icon-close"
                      circle
                      size="mini"
                      @click="delRight(scope.row)"
                  ></el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button
            size="medium"
            @click="dialogVisible = false"
            v-if="clickType != 'right'"
        >取 消</el-button
        >
        <el-button
            size="medium"
            type="primary"
            @click="handleEdit"
            v-if="clickType != 'right'"
        >提 交</el-button
        >
      </span>

      <el-dialog
          width="30%"
          title="选择关联会员权益"
          :visible.sync="innerVisible"
          append-to-body
          :close-on-click-modal="false"
      >
        <el-form label-width="80px">
          <el-form-item class="item" label="权益列表">
            <el-select
                v-model="innerChecked.code"
                multiple
                placeholder="请选择"
            >
              <el-option
                  v-for="item in allVipRight"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="innerVisible = false">取 消</el-button>
          <el-button type="primary" @click="handelInnerRight">确定</el-button>
        </div>
      </el-dialog>
    </el-dialog>
  </section>
</template>
<script>
import {PAGE_SIZE, COMMON_STATUS} from "@/config";

import {ossUpload} from "@utils/filters/upload";
// 标题
const titleConfig = {
  "ql-bold": "加粗",
  "ql-color": "颜色",
  "ql-font": "字体",
  "ql-code": "插入代码",
  "ql-italic": "斜体",
  "ql-link": "添加链接",
  "ql-background": "背景颜色",
  "ql-size": "字体大小",
  "ql-strike": "删除线",
  "ql-script": "上标/下标",
  "ql-underline": "下划线",
  "ql-blockquote": "引用",
  "ql-header": "标题",
  "ql-indent": "缩进",
  "ql-list": "列表",
  "ql-align": "文本对齐",
  "ql-direction": "文本方向",
  "ql-code-block": "代码块",
  "ql-formula": "公式",
  "ql-image": "图片",
  "ql-video": "视频",
  "ql-clean": "清除字体样式",
  "ql-upload": "文件",
};
import richText from "../../components/richText.vue";

export default {
  data() {
    var checkDays = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("会员天数不能为空"));
      }
      setTimeout(() => {
        if (value <= 0) {
          callback(new Error("必须大于0"));
        } else {
          callback();
        }
      }, 500);
    };
    var checkLevel = (rule, value, callback) => {
      if (!value || value == "") {
        return callback(new Error("会员等级不能为空"));
      }
      setTimeout(() => {
        if (value <= 0) {
          callback(new Error("必须大于0"));
        } else {
          callback();
        }
      }, 500);
    };
    return {
      editorOption: {
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"], // toggled buttons
              ["blockquote", "code-block"],

              [{header: 1}, {header: 2}], // custom button values
              [{list: "ordered"}, {list: "bullet"}],
              [{script: "sub"}, {script: "super"}], // superscript/subscript
              [{indent: "-1"}, {indent: "+1"}], // outdent/indent
              [{direction: "rtl"}], // text direction

              // [{ size: ["small", false, "large", "huge"] }], // custom dropdown
              // [{ header: [1, 2, 3, 4, 5, 6, false] }],

              // [{ color: [] }, { background: [] }], // dropdown with defaults from theme
              // [{ font: [] }],
              [{align: []}],
              ["image"], //"link", "video"
              // ["clean"], // remove formatting button
            ],

            handlers: {
              shadeBox: null,
              insertMetric: function () {
                //方法体
                alert(1);
              },
            },
          },
        },
      },

      PAGE_SIZE,
      COMMON_STATUS,
      loading: false, //加载中--外层表格

      loading1: false, //加载中--icon
      loading2: false, //加载中--背景图
      loading3: false, //加载中--内层表格

      //上一级展示的词语
      // dictDataSelect: "",
      // 分页
      page: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      // defaultProps: {
      //   children: "orgs",
      //   label: "name",
      // },
      permissionData: [], //组织--菜单树
      // treeList: [],
      treeList_one: [],
      optionList: [
        {
          value: "1",
          label: "修改",
        },
        {
          value: "2",
          label: "删除",
        },
      ],
      search: {},
      // input_search: "",
      // value: "", //select1
      value1: "", //select2
      value2: true,

      dialogVisible: false, //弹出框显示隐藏
      innerVisible: false, //内层弹框
      clickType: "", //弹窗类型
      params: {}, //弹窗修改数据
      rules: {
        name: [
          {required: true, message: "请填写名称", trigger: "change"},
          {max: 10, message: "不超过10个字符"},
        ],
        code: [
          {required: true, message: "请填写唯一标识", trigger: "change"},
        ],
        level: [
          {
            required: true,
            validator: checkLevel,
            trigger: "blur",
            type: "number",
            message: "等级不为0和空,且为数字值",
          },
        ],
        payPrice: [
          {
            required: true,
            validator: checkDays,
            message: "价格不为0和空,且为数字值",
            trigger: "blur",
          },
        ],
        days: [
          {
            required: true,
            validator: checkDays,
            trigger: "blur",
            type: "number",
            message: "等级不为0和空,且为数字值",
          },
        ],
      }, //表单验证提示

      tableData: [], //二级--组织列表
      srcList: [], //上传图片数组
      srcListBg: [], //背景图列表
      isMoer: true,
      isMoerBg: true, //背景图加号

      rightData: [], //权益列表--关联到每一个vip
      allVipRight: [], //所有的权益列表
      innerChecked: {code: []}, //以及选择的权益
      maxIndex: 0, //权益列表长度

      logoSrcList:[],
      logoLoading:false,
      isLogoMoer:false,

      addShow: false,
      deleteShow: false,
      editShow: false,
      statusShow: true,
      searchShow: false,
      benefitShow: false



    };
  },
  components: {
    richText,
  },
  created() {
    this.getAllVipRight();
    this.getVipList();
    this.getPermissionButtonList()
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false && this.params != {}) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
        this.srcList = [];
        this.srcListBg = [];
        this.isMoer = true;
        this.isLogoMoer = true;
        this.logoSrcList = []
      }
    },
    innerVisible() {
      if (this.innerVisible == false) {
        this.innerChecked.code = [];
      }
    },
  },
  methods: {
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'vip:info:benefit') {
            this.benefitShow = true
          }
          if (item.code == 'vip:info:query') {
            this.searchShow = true
          }
          if (item.code == 'vip:info:add') {
            this.addShow = true
          }
          if (item.code == "vip:info:delete") {
            this.deleteShow = true
          }
          if (item.code == "vip:info:edit") {
            this.editShow = true
          }
          if(item.code == "vip:info:status"){
            this.statusShow = false
          }
        })
      }
    },

    arraySpanMethod({row, column, rowIndex, columnIndex}) {
      if (rowIndex === this.rightData.length) {
        if (columnIndex === 0) {
          return [1, 5];
        } else if (columnIndex === 1) {
          return [0, 0];
        }
      }
    },
    /**
     *  table  //left menu  //search
     */
    async getVipList() {
      let http = "/vip/info/list";
      this.loading = true;
      //组织列表
      const {data: resData} = await this.$get(http, {
        params: {...this.search, ...this.page},
      });
      this.loading = false;
      this.tableData = resData.data;
    },

    //switch状态改变 --接口
    handleSwitch(index) {
      this.$put(`/vip/info/info/status/${this.tableData[index].code}`).then(res => {
        if (res.data.result == 200) {
          this.$message.success('操作成功')
        }
      });
    },
    //删除--会员等级
    del(row) {
      this.$confirm("一旦删除无法恢复, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `/vip/info/info/${row.code}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.getVipList();
        this.$message.success("删除成功!");
      });
    },

    // 弹窗
    handleClick(type, row = {}) {
      this.clickType = type;
      if (type == "change" || type == "right") {
        //修改  change
        if (type == "change") {
          this.$get(`/vip/info/info/${row.code}`).then((res) => {
            if (res.data.data != undefined) {
              res.data.data.payPrice = Number(res.data.data.payPrice) / 100
              this.params = res.data.data;
              //回显图片
              if (row.logo) {
                this.logoSrcList = [];
                this.isLogoMoer = false;
                this.logoSrcList.push(row.logo);
              } else {
                this.logoSrcList = [];
                this.isLogoMoer = true;
              }
              //回显图片
              if (row.icon) {
                this.srcList = [];
                this.isMoer = false;
                this.srcList.push(row.icon);
              } else {
                this.srcList = [];
                this.isMoer = true;
              }
              // 回显背景图片
              for (const key in row) {
                if (key.indexOf("bgimg") != -1) {
                  if (row[key] != "" && row[key] != undefined) {
                    this.srcListBg.push(row[key]);
                  }
                }
              }
              if (this.srcListBg.length >= 4) {
                this.isMoerBg = false;
              } else {
                this.isMoerBg = true;
              }
              this.dialogVisible = true;
            }
          });
        }
        if (type == "right") {
          this.params = JSON.parse(JSON.stringify(row));
          this.getRightList();
          this.dialogVisible = true;
        }
      } else {
        //添加
        this.params = {};
        this.dialogVisible = true;
      }
    },
    //窗口--提交 修改信息
    handleEdit() {

      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        this.$confirm("确认提交修改, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          this.params.payPrice = this.params.payPrice * 100
          if (this.clickType == "addNext") {
            this.params.icon = JSON.parse(JSON.stringify(this.srcList[0]));
            const {data: resData} = await this.$post(
                "/vip/info/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );
            if (resData.result != 200) return;
            this.getVipList(); //重新获取数据
            this.dialogVisible = false; //弹窗隐藏
            this.$message.success("添加成功!");
          } else {
            if (this.clickType == "change") {
              //修改
              if (this.srcList.length) {
                this.params.icon = JSON.parse(JSON.stringify(this.srcList[0]));
              }

              // 回显背景图片--修改--提交
              for (const key in this.params) {
                if (key.indexOf("bgimg") != -1) {
                  this.params[key] = "";
                  delete this.params.key;
                }
              }

              if (this.srcListBg && this.srcListBg.length) {
                for (let i = 0; i < this.srcListBg.length; i++) {
                  this.params[`bgimg${i + 1}`] = JSON.parse(
                      JSON.stringify(this.srcListBg[i])
                  );
                }
              }
              const {data: resData} = await this.$put(
                  "/vip/info/info",
                  this.params,
                  {
                    headers: {
                      isLoading: true,
                    },
                  }
              );
              if (resData.result != 200) return;
              this.getVipList(); //重新获取数据
              this.dialogVisible = false; //弹窗隐藏
              this.$message.success("修改成功!");
            } else {
              //会员权益关联
            }
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      });
    },

    //弹窗打开  --获取关联的权益列表
    async getRightList() {
      this.innerChecked.code = [];
      this.rightData = []; //clear
      this.loading3 = true;
      const {data: res} = await this.$get(
          `/vip/item/list?status=1&vipCode=${this.params.code}`
      );
      if (res.data) {
        this.rightData = res.data;
        for (const i in this.rightData) {
          this.innerChecked.code.push(this.rightData[i].code); //加入回显数据
        }
      } else {
        this.rightData = [];
      }
      this.loading3 = false;
    },
    //获取所有会员权益--下拉选择列表
    async getAllVipRight() {
      let http = "/vip/item/list";
      const {data: resData} = await this.$get(http);
      if (resData.data) {
        this.allVipRight = resData.data;
      }
    },
    //会员权益绑定--点击确定
    async handelInnerRight() {
      let temp = {
        code: this.params.code,
        vipItemCodes: this.innerChecked.code,
      };
      const {data: resData} = await this.$post(`/vip/info/items`, temp, {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      this.getRightList();
      this.$message.success("关联权益成功!");
      this.innerVisible = false;
    },
    //删除关联的权益
    async delRight(row) {
      const {data: resData} = await this.$delete(
          `/vip/info/item/${this.params.code}/${row.code}`
      );
      this.getRightList();
      if (resData.result != 200) return;
    },

    /**
     * 阿里云OSS签名
     */
    getPolicy() {
      this.$refs.file.dispatchEvent(new MouseEvent("click"));
    },
    async getFile() {
      this.loading1 = true;
      const that = this;
      const {data: resData} = await this.$get("/aliyun/oss/sign", {});
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.file.files[0],
          resData.data,
          "one" //'more','one'
      );
      this.isMoer = false;
      this.loading1 = false;
      this.srcList = addRoutes;
      this.params.icon = this.srcList[0];
    },

    getLogoPolicy() {
      this.$refs.logofile.dispatchEvent(new MouseEvent("click"));
    },

    async getLogoFile() {
      this.logoLoading = true;
      const that = this;
      const {data: resData} = await this.$get("/aliyun/oss/sign", {});
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.logofile.files[0],
          resData.data,
          "one" //'more','one'
      );
      this.isLogoMoer = false;
      this.logoLoading = false;
      this.logoSrcList = addRoutes;
      this.params.logo = this.logoSrcList[0];
    },

    /* 多张图片上传 */
    getPolicyBg() {
      this.$refs.fileBg.dispatchEvent(new MouseEvent("click"));
    },
    async getfileBg() {
      this.loading2 = true;
      const that = this;
      const {data: resData} = await this.$get("/aliyun/oss/sign", {});
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.fileBg.files[0],
          resData.data,
          "more", //'more','one'
          this.srcListBg
      );
      this.loading2 = false;
      this.srcListBg = addRoutes;
      if (this.srcListBg.length >= 4) {
        this.isMoerBg = false;
        // 背景图最多有4张
      } else {
        this.isMoerBg = true;
      }
    },
    removeUploading(index) {
      this.srcListBg.splice(index, 1);
      // this.params
      // for (const key in this.params) {
      //   if (key.indexOf("bgimg") != -1) {
      //     // this.params[key] = "";
      //     delete this.params.key;
      //   }
      // }
    },
  },
};
</script>
